module.exports = __webpack_public_path__ + "static/img/exclusive_zh.482b0c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/product-icon/exclusive_zh.png
// module id = xCxz
// module chunks = 71